import React from "react";
import { Button, Col, Container, Row } from "reactstrap";
import { MdArrowBack } from "react-icons/md";
import Link from "next/link";

import SearchBar from "./search-bar";
import { routes } from "@/utils/routes";
import { CategoryKeys, CategoryType } from "@/@types/help/Articles";
import { articleMapping, categoryMapping } from "./help-articles-data";
import { useRouter } from "next/router";

type Props = {
  collection: any;
};

const CollectionMain = ({ collection }: Props) => {
  const router = useRouter();

  return (
    <main>
      <Container>
        <SearchBar basePath={routes.help} />
        <Button outline onClick={() => router.push(routes.help)}>
          <MdArrowBack /> Go Back
        </Button>
        <hr />
        <h3>{collection?.title}</h3>
        {collection?.categories?.map((cat: CategoryKeys, i: number) => {
          const { title, articles, link: catLink } = categoryMapping[cat];

          return (
            <div key={i}>
              <hr />
              <h4>{title}</h4>
              <Row>
                {articles?.map((a, ai) => {
                  const { title, link: artLink } = articleMapping[a];
                  const partialPath = [collection.link, catLink, artLink].join(
                    "/"
                  );

                  return (
                    <Col key={artLink} xs={12} md={6}>
                      <Link href={`${routes.help}/${partialPath}`}>
                        {title}
                      </Link>
                    </Col>
                  );
                })}
              </Row>
            </div>
          );
        })}
      </Container>
    </main>
  );
};

export default CollectionMain;
